import React from 'react';
import { BookOpen, Briefcase } from 'lucide-react';

const About = () => {
  return (
    <div className="bg-white">
      {/* Header */}
      <div className="bg-primary py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-extrabold text-white sm:text-5xl">About Eccisoft</h1>
          <p className="mt-4 text-xl text-slate-300 max-w-2xl mx-auto">
            A leader in reliability engineering and risk sciences, dedicated to solving complex system challenges.
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        {/* Company Overview */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-slate-900 mb-6">Our Story</h2>
          <p className="text-lg text-slate-600 leading-relaxed mb-4">
            Eccisoft was founded on the principle that complex systems require rigorous, data-driven analysis to ensure safety and reliability. With decades of collective experience in the field, our team has partnered with government agencies, aerospace giants, and leading technology companies to deliver state-of-the-art solutions.
          </p>
          <p className="text-lg text-slate-600 leading-relaxed">
            Our unique blend of technical proficiency in reliability engineering and modern software development allows us to not only assess risks but also build the tools and systems to manage them effectively.
          </p>
        </div>

        {/* Leadership */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-slate-900 mb-8">Our Experts</h2>
          <div className="bg-slate-50 rounded-2xl p-8 border border-slate-100 flex flex-col md:flex-row gap-8 items-start">
            <div className="w-32 h-32 bg-slate-200 rounded-full flex-shrink-0 mx-auto md:mx-0"></div> {/* Placeholder for headshot */}
            <div>
              <h3 className="text-2xl font-bold text-slate-900">Dr. Dongfeng Zhu</h3>
              <p className="text-accent font-medium mb-4">Principal Consultant</p>
              <p className="text-slate-600 mb-6">
                Dr. Zhu leads our technical initiatives with over 20 years of experience in reliability engineering and risk sciences. His background includes key roles at major research institutions and technology companies, driving innovation in system safety and resilience.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex items-start">
                  <BookOpen className="h-5 w-5 text-primary mt-1 mr-2" />
                  <div>
                    <h4 className="font-semibold text-slate-900">Education</h4>
                    <p className="text-sm text-slate-600">Ph.D. Reliability Engineering, UMD</p>
                    <p className="text-sm text-slate-600">MS/BS Engineering Physics, Tsinghua Univ.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Briefcase className="h-5 w-5 text-primary mt-1 mr-2" />
                  <div>
                    <h4 className="font-semibold text-slate-900">Experience</h4>
                    <p className="text-sm text-slate-600">UCLA, Google, NIRA, ITEM Software</p>
                    <p className="text-sm text-slate-600">NASA, FAA, NRC Projects</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  );
};

export default About;
